/** Browser-side storage for the tool gate token. Call only from effects or handlers. */
const KEY = "ajility_tool_gate";

export function readGateToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeGateToken(token: string) {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* storage blocked: the report still unlocks for this page view */
  }
}

/** Reads the display fields from the signed token body (not trusted server-side). */
export function gateIdentity(token: string | null): { firstName: string; businessName: string | null } | null {
  if (!token) return null;
  try {
    const body = token.split(".")[0]!;
    const p = JSON.parse(atob(body.replace(/-/g, "+").replace(/_/g, "/")));
    return { firstName: String(p.f ?? ""), businessName: p.b ? String(p.b) : null };
  } catch {
    return null;
  }
}

export function attribution() {
  try {
    const q = new URLSearchParams(window.location.search);
    return {
      utmSource: q.get("utm_source"),
      utmMedium: q.get("utm_medium"),
      utmCampaign: q.get("utm_campaign"),
      referrer: document.referrer || null,
    };
  } catch {
    return {};
  }
}

export async function postToolLead(body: Record<string, unknown>) {
  const res = await fetch("/api/public/tool-leads", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...body, ...attribution() }),
  });
  const data = (await res.json().catch(() => ({}))) as { ok?: boolean; token?: string; error?: string; fields?: Record<string, string[]> };
  return { ok: res.ok && data.ok === true, ...data };
}
